import { createDivWithElements, createHomewardButton, removeByClassName, setBackground } from '../../shared/helpers';
import { BOOKS } from './constants';
import './books.css';
import { COLORS } from '../../shared/constants';

function leaveBooks() {
  removeByClassName('books');
}

export function lookAtBooks() {
  setBackground(COLORS.white);
  const all = document.getElementsByTagName('html')[0];
  const covers = BOOKS.map(book => {
    const cover = book.showCover()
    cover.classList.add('books');
    cover.addEventListener('click', () => {
      leaveBooks();
      book.show(lookAtBooks);
    });
    cover.style.transform = `rotate(${Math.random() * 80 - 40}deg)`
    return cover;
  });
  const spreadOutBooks = createDivWithElements(covers, ['books'], 'spread-out-books');
  all.append(spreadOutBooks);
}